export default {
  auth: {
    password: {
      reset: '/password/email'
    }
  }
}
